export interface CategoryItem {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const categories: CategoryItem[] = [
  {
    slug: "rexue",
    name: "热血",
    icon: "ri-fire-line",
    description: "燃爆全场的战斗番，点燃你的热血之魂",
    count: 5,
  },
  {
    slug: "lianai",
    name: "恋爱",
    icon: "ri-heart-line",
    description: "甜甜的恋爱故事，治愈你的每一天",
    count: 4,
  },
  {
    slug: "gaoxiao",
    name: "搞笑",
    icon: "ri-emotion-laugh-line",
    description: "笑到停不下来的欢乐番剧",
    count: 4,
  },
  {
    slug: "qihuan",
    name: "奇幻",
    icon: "ri-magic-line",
    description: "奇幻世界冒险，想象力无极限",
    count: 3,
  },
];

export function getCategoryBySlug(slug: string): CategoryItem | undefined {
  return categories.find((c) => c.slug === slug);
}